import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import UserList from '../views/UserList.vue'
import TransferRecord from '../views/TransferRecord.vue'
import BatchGenerateConfig from '../views/BatchGenerateConfig.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue'),
    meta: { public: true }
  },
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/user-list/:platform',
    name: 'UserList',
    component: UserList
  },
  {
    path: '/transfer-record/:platform/:userId',
    name: 'TransferRecord',
    component: TransferRecord
  },
  {
    path: '/batch-generate-config/:platform/:userId',
    name: 'BatchGenerateConfig',
    component: BatchGenerateConfig
  }
]

const router = new VueRouter({
  routes
})

// 全局前置守卫：未登录则跳转登录页
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('bankflow_token')
  if (to.meta && to.meta.public) {
    // public 路由（如登录页）直接放行
    return next()
  }
  if (!token) {
    return next({
      path: '/login',
      query: { redirect: to.fullPath }
    })
  }
  next()
})

export default router
